const unSentMessages = (state = {}, action) => {
  switch (action.type) {
    case 'SAVE_NEW_MESSAGE_EDITOR_STATE':
      return {
        ...state,
        [action.conversationObjId]: {
          ...state[action.conversationObjId],
          editorState: action.editorState,
          decisionTreeCouponCode: action.decisionTreeCouponCode,
        },
      };

    case 'CLEAR_UNSENT_MESSAGE':
      let newState = {
        ...state,
      };
      delete newState[action.conversationObjId];

      return newState;

    case 'INSERT_TEXT_AT_CURSOR': {
      const existing = state[action.conversationObjId] || {};
      const seq = (existing.pendingCaretInsert && existing.pendingCaretInsert.seq) || 0;

      return {
        ...state,
        [action.conversationObjId]: {
          ...existing,
          // NewMessage watches this token and inserts the text at the live
          // editor caret (then clears nothing — the bumped seq guards re-runs).
          pendingCaretInsert: { text: action.text, seq: seq + 1 },
        },
      };
    }

    case 'CLEAR_PENDING_CARET_INSERT': {
      const existing = state[action.conversationObjId];
      if (!existing || !existing.pendingCaretInsert) {
        return state;
      }
      const { pendingCaretInsert, ...rest } = existing;

      return {
        ...state,
        [action.conversationObjId]: rest,
      };
    }

    case 'SET_NEW_MESSAGE_COUPON_CODE_TYPE':
      return {
        ...state,
        [action.conversationObjId]: {
          ...state[action.conversationObjId],
          macroCouponCodeTypeId: action.macroCouponCodeTypeId,
        },
      };

    default:
      return state;
  }
};

export default unSentMessages;
